import EnCountry from '@/data/countries.json'

function initCountryDict() {
    let countryDict = EnCountry.reduce(function(map, obj) {
        map[obj.alpha3] = obj.country
        return map
    }, {})
    return countryDict
}

export default {
    videoDict: {}, // Video dictionary that used ID as key
    videoList: [], // Video array sorted by update time
    videoListCN: [], // Video array sorted by update time /CN
    isShowPoster: true,
    currentSelectVideo: null,
    countryData: EnCountry,
    countryDict: initCountryDict(), // country dictionary that used alpha3 as key
    userInfo: null,
    sharingVideoURL: null,
    givePetalVideo: null,
    userBalance: 0,
    nextDailyRewardTime: 0,
    activePoint: localStorage.getItem('user_ap') || 0,
    sharedVideoCount: localStorage.getItem('shared_video_count') || 0,
    searchCategory: 'tvseries',
    searchSubCategory: 'all',
    searchLanguage: 'all',
    searchSubtitleLanguage: 'all',
    adminToken: 'PetalChatRoomAdmin',
    country: 'HK',
    isChangeNavBarStyle: false,
    isPcClient: true
}



// WEBPACK FOOTER //
// ./src/store/state.js